import Portfolio from '../components/Portfolio';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FloatingContactWidget from '../components/FloatingContactWidget';
import { useTheme } from '../contexts/ThemeContext';

const PortfolioPage = () => {
    const { isDark } = useTheme();
    return (
        <div className={`min-h-screen ${isDark ? 'bg-gray-900' : 'bg-white'} transition-colors duration-300`}>
            <Navbar />
            <Portfolio />
            <Footer />
            <FloatingContactWidget />
        </div>
    );
};

export default PortfolioPage;
